import OriginalAccordion from './Accordion.svelte';
import OriginalItem from './Item.svelte';
import Title from './Title.svelte';
import Content from './Content.svelte';
const Accordion = OriginalAccordion;
Accordion.Item = OriginalItem;
Accordion.Item.Title = Title;
Accordion.Item.Content = Content;
export default Accordion;
